/**
 * "Are there featured special offers to show?" query hook.
 *
 * The lobby renders the Special Offers section only when at least one featured
 * offer exists. This returns a boolean view-model; the section content itself is
 * fetched by OffersSection. Gated on login (anonymous visitors never see it).
 */

import { useQuery } from "@tanstack/react-query";
import casinoService from "../../../services/casinoService";
import { queryKeys } from "../../../shared/data/queryKeys";
import { normalizeQueryError } from "../../../shared/data/errors";

/**
 * @param {boolean} isLoggedIn - gates the query (section is logged-in only)
 */
export function useSpecialOffersAvailable(isLoggedIn) {
  return useQuery({
    queryKey: queryKeys.games.specialOffersAvailable(),
    enabled: Boolean(isLoggedIn),
    queryFn: async () => {
      try {
        const response = await casinoService.getOffers({
          featured: true,
          limit: 3,
        });
        // Backend returns { data: [...], meta: {...} }.
        return Boolean(
          response &&
            Array.isArray(response.data) &&
            response.data.length > 0,
        );
      } catch (err) {
        throw normalizeQueryError(err, "Failed to check special offers");
      }
    },
  });
}

export default useSpecialOffersAvailable;
